(function () {
  Flint.file('mframework/views/facebookPhotoImage.js', function (require) {
    Flint.staticStyles('FacebookPhotoImage', {
      '$image': '#_flintapp image.FacebookPhotoImage, #_flintapp .FacebookPhotoImage.image, #_flintapp .ViewFacebookPhotoImage.image, #_flintapp .FacebookPhotoImage > .image'
    }, {
      '$image': {
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: '50% 50%'
      }
    });
    Flint.view('FacebookPhotoImage', function (view, on, $) {
      var pro = initPro(view, {
        photo: M.mapAtom(),
        width: M.defaultAtom(400),
        height: M.defaultAtom(300),
        style: M.mergeAtom({})
      });

      var bestImage = pro.photo.derive(function (photo) {
        photo = photo.toJS();

        var best = null;
        photo.images.forEach(function (image) {
          if (!best || image.width <= pro.width.get() && best.width < image.width || pro.width.get() <= image.width && image.width < best.width) {
            best = image;
          }
        });
        return immutable.fromJS(best);
      });view.render(function () {
        return view.el(['image', 1], { src: bestImage.get().get('source'),
          style: pro.style.get().toJS()
        });
      });

      $["image"] = function (_, _index) {
        return {
          width: pro.width.get(),
          height: pro.height.get(),
          backgroundImage: 'url(' + bestImage.get().get('source') + ')' };
      };
    });
  })
})();
//# sourceMappingURL=facebookPhotoImage.js.map
